import { CommonModule } from '@angular/common';
import {
  Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  IconColors, IconSizes,
} from '@sondermindorg/iris-design-system-angular';
import { IrisIconModule } from '@sondermind/iris/icon';
import { SessionType, SessionTypeDisplay } from '@sondermind/utilities/models-session';
import { BreakpointsService } from '@sondermind/utilities/services';

import { IProviderShareableProfile, StateInfoType } from '../../shareable-link.interfaces';
import { IRequestSessionParams } from '../../models/request-session-params.interface';
import {
  NonAcceptingMatchOptionsComponent
} from '../non-accepting-match-options/non-accepting-match-options.component';

@Component({
  selector: 'landing-page-header',
  standalone: true,
  imports: [
    CommonModule,
    IrisIconModule,
    RouterModule,
    NonAcceptingMatchOptionsComponent
  ],
  templateUrl: './landing-page-header.component.html',
  styleUrls: ['./landing-page-header.component.scss']
})
export class LandingPageHeaderComponent implements OnInit {
  @Input() providerShareableProfile!: IProviderShareableProfile;
  @Input() showSimilarProvidersFf: boolean = false;
  @Input() useCheckoutFormFf: boolean = false;
  @Input() alwaysShowAcceptingFf: boolean = false;
  @Input() paramsShareCode: string = '';
  @Input() paramsName: string = '';
  @Input() requestSessionQueryParams: IRequestSessionParams = null; // For tracking the user coming from .com site
  @Output() requestASessionClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  credentialStatesFormatted: string = '';
  maxLengthOfInsuranceListString = 56;
  noProfilePhoto: boolean = true;
  providerInsurances: string = '';
  sessionTypeString: string = '';

  showAccepting: boolean = true;

  iconColor: IconColors = IconColors.BRAND1;
  iconSizes = IconSizes;

  constructor(public breakpointService: BreakpointsService) {}

  ngOnInit(): void {
    this.noProfilePhoto = this.providerShareableProfile.profile_photo_url.endsWith('/missing.png');

    this.sessionTypeString = this.formatSessionTypeList(this.providerShareableProfile.session_types_offered);

    this.providerInsurances = this.providerShareableProfile.insurances.join(', ');

    if (this.providerShareableProfile.credentialed_states.length > 0) {
      this.credentialStatesFormatted = this.formatCredStates(this.providerShareableProfile.credentialed_states);
    }

    this.showAccepting = this.alwaysShowAcceptingFf || this.providerShareableProfile.accepting_clients;
  }

  private formatSessionTypeList(sessionTypes: string[]): string {
    const arrayToJoin: string[] = [];

    if (sessionTypes.includes(SessionType.IN_PERSON)) {
      arrayToJoin.push(SessionTypeDisplay.IN_PERSON);
    }
    if (sessionTypes.includes(SessionType.VIDEO)) {
      arrayToJoin.push(SessionTypeDisplay.VIDEO);
    }

    return arrayToJoin.join(', ');
  }

  private formatCredStates(states: StateInfoType[]): string {
    let formattedString = '';

    states.forEach((state, i) => {
      if (i !== 0 && i < states.length - 1) {
        formattedString += ', ';
      }
      if (states.length > 2 && i === states.length - 1) {
        // oxford comma
        formattedString += ',';
      }
      if (states.length > 1 && i === states.length - 1) {
        formattedString += ' and ';
      }
      formattedString += state.name;
    });

    return formattedString;
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onRequestASessionClick(isLinkToFlow: boolean): void {
    this.requestASessionClicked.emit(isLinkToFlow);
  }
}
